var _dec, _class;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import { connect } from 'react-redux';
import { withStyle, jsx } from '@instructure/emotion';
import { formatCaptureTime } from '../../../utils';
import { CaptureStates } from '../../../constants/CaptureStates';
import generateStyle from './styles';
import generateComponentTheme from './theme';

/**
---
private: true
---
@module RecordingBadge
**/
let RecordingBadge = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = class RecordingBadge extends Component {
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  render() {
    const _this$props = this.props,
      styles = _this$props.styles,
      time = _this$props.time,
      captureState = _this$props.captureState;
    const formattedTime = formatCaptureTime(time);
    return captureState === CaptureStates.RECORDING ? jsx("div", {
      css: styles.badge
    }, jsx("div", {
      css: styles.signal
    }), jsx("div", {
      css: styles.timer
    }, formattedTime)) : null;
  }
}) || _class);
const mapStateToProps = state => ({
  time: state.timeElapsed,
  captureState: state.captureState
});
export default connect(mapStateToProps)(RecordingBadge);